.zone {
    height: 8px;
    display: flex;
    align-items: center;
}

.zone--empty-page {
    height: auto;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;
    box-sizing: border-box;
    padding: 16px;
    margin-bottom: 16px;
}

.zone--empty-page-active {
    background-color: rgba(59, 158, 215, 0.1);
    border-radius: 8px;
    outline: 1px dashed var(--blue);
    outline-offset: -1px;
}

.indicator {
    height: 2px;
    width: 100%;
    background-color: var(--blue);
    border-radius: 1px;
}
